import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from 'utils/useLanguage';

import { pageRoutes } from 'config/router/pageRoutes';
import { ArrowLeftCircle, ArrowRightCircle } from 'react-bootstrap-icons';

interface Props {
  title: string;
  subTitle?: string | React.ReactNode;
}

const PageHeader = ({ title, subTitle }: Props) => {
  const navigate = useNavigate();
  const { direction } = useLanguage();
  const handleBack = () => {
    navigate(pageRoutes.orders);
  };
  return (
    <div className="d-flex align-items-center">
      <button className="btn me-3 text-primary" onClick={handleBack}>
        {direction === 'rtl' ? <ArrowRightCircle height={24} width={24} /> : <ArrowLeftCircle height={24} width={24} />}
      </button>
      <div className="d-flex flex-column">
        <h4 className="fs-4 fw-bold m-0 ">{title}</h4>
        <span className="fs-6">{subTitle}</span>
      </div>
    </div>
  );
};

export default PageHeader;
